import { useState, useEffect, useRef } from 'react';
import { WidgetProps } from '@rjsf/utils';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import { dataStoresOptions } from "./defaults/defaults";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';

export const NodeDataStoreMultiSelectWidget = (props: WidgetProps) => {
    const { value, onChange, formContext, registry, schema, disabled } = props;
    let vals = [];
    if (value !== undefined && value.length > 0) {
        vals = value.split(',');
    }


    const [selected, setSelected] = useState<string[]>(vals);

    // function changeValue(event) {
    //     debugger;
    //     let polp = event.target.value;
    //     let vals: string = selected;
    //     if (vals === undefined) {
    //         vals = '';
    //     }
    //     let valsArray: string[] = vals.split(',');
    //     if (!valsArray.includes(polp)) {
    //         valsArray.push(polp);
    //         const valString = valsArray.join(',');
    //         setSelected(valString);
    //         onChange(valString)
    //     }
    // }

    function handleChange(e: SelectChangeEvent) {
        const targetVal = e.target.value;
        let val = typeof targetVal === 'string' ? targetVal.split(',') : targetVal;
        setSelected(
            val
        );
        onChange(val.join(','));
    }

    return (
        <div className="dialog__node-data-management custom-form-widget">
            <div className='node-data-management__controls'>
                <div className="controls__fields">
                    {/*<Select*/}
                    {/*    multiple*/}
                    {/*    value={selected}*/}
                    {/*    input={<OutlinedInput label="Name" />}*/}
                    {/*    onChange={(e: SelectChangeEvent) => handleChange(e)}*/}
                    {/*    >*/}
                    {/*    { dataStoresOptions.map( (store: { id: string, value: string }, index : number) => (*/}
                    {/*        <MenuItem key={ 'data_store_item_' + index  }  value={ store.id }>{ store.value }</MenuItem>*/}
                    {/*    ) ) }*/}
                    {/*</Select>*/}

                    {/*<select*/}
                    {/*    disabled={ disabled }*/}
                    {/*    className="custom-multi-select"*/}
                    {/*    multiple value={value} onChange={(e) => changeValue(e) } >*/}
                    {/*    { dataStoresOptions.map( (store: { id: string, value: string }, index : number) => (*/}
                    {/*        <option key={ 'data_store_item_' + index  }  value={ store.id }>{ store.value }</option>*/}
                    {/*    ) ) }*/}
                    {/*</select>*/}
                </div>
            </div>
        </div>
    );
}